

















import { Vue, Component, Prop } from 'vue-property-decorator';
import IconStopSale from '@/components/icons/IconStopSale.vue';
import { mapState } from 'vuex';

@Component({
  components: { IconStopSale },
  computed: mapState(['partner']),
})
export default class ToastMessage extends Vue {
  @Prop() public type!: string;
  @Prop() public message!: string;
  @Prop() public replace!: any;
  @Prop() public errorCode!: string;
  @Prop() public errorData!: any;
  @Prop() public timeout!: any;
  @Prop() public title!: string;
  @Prop() public callback!: any;
  @Prop({ default: true}) public dismissBtn!: boolean;
  public partner: any;

  public dismissModal() {
    this.$store.commit('removeToast', this.callback);
  }

}
